export const SUPPORTED_LANGUAGES = {
  EN: 'en',
  ES: 'es',
} as const
